// extracted by mini-css-extract-plugin
export default {"bodyContainer":"DeskBookingAction_bodyContainer__u45hP"};